import React, { createContext, useContext, useState } from 'react'
import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { SpinnerContext, ToastContext } from '../../utils/shared.module'
import { toast } from 'react-toastify'
import store from '../../store/store'
import { logout } from '../../store/loginSlice'
import Loader from '../loader/loader'
import { end_points } from '../core.index'
// import { end_points } from '../end_points/end_points'
const getDefaultLoadingStatus = () =>
  window.location.pathname.startsWith('/invitation')
export const AxiosContext = createContext<any>({})

const AxiosProvider = (props: { children: any }) => {
  const axiosInstance: AxiosInstance = axios.create()
  const { showLoader, hideLoader } = useContext(SpinnerContext)
  const [loading, setLoading] = useState(getDefaultLoadingStatus())

  const hideLoadersApi: Array<string | undefined> = [end_points.roleModel.url]

  axiosInstance.interceptors.request.use(
    async (config: any) => {
      if (!hideLoadersApi.includes(config.url)) {
        showLoader()
        !getDefaultLoadingStatus() && setLoading(true)
      }

      const token = store?.getState()?.login?.token
      config.baseURL = API_URL
      if (
        config.url === end_points.layoutsAdd.url ||
        config.url === end_points.personal_account.url ||
        config.url === end_points.submit_company_profile.url ||
        config.url.startsWith(end_points.comapaniesAdd.url) ||
        config.url.startsWith(end_points.vesselsCreate.url) ||
        config.url.startsWith(end_points.vesselsUpdate.url) ||
        config.url.startsWith(end_points.vesselEquipmentsCreate.url) ||
        config.url.startsWith(end_points.vesselEquipmentsUpdate.url) ||
        config.url.startsWith(end_points.workPictureAdd.url) ||
        config.url.startsWith(end_points.serviceDocumentAdd.url) ||
        config.url.startsWith(end_points.serviceFormAdd.url) ||
        config.url.startsWith(end_points.vesselsDocumentAdd.url) ||
        config.url.startsWith(end_points.salesEstimateSignatureUpdate.url)
      ) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          token: `${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        }
      } else {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          token: `${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }
      }

      return config
    },
    (error) => {
      !getDefaultLoadingStatus() && setLoading(false)
      hideLoader()
      return Promise.reject(error)
    },
  )
  const handleLoaderCustom = (status: boolean) => {
    setLoading(status)
  }
  axiosInstance.interceptors.response.use(
    async (response: AxiosResponse) => {
      !getDefaultLoadingStatus() && setLoading(false)
      hideLoader()
      await handleResponseStatus(response)
      if (getDefaultLoadingStatus()) {
        response.customLoaderStateHandler = handleLoaderCustom
      }
      return response
    },
    async (error) => {
      setLoading(false)
      hideLoader()
      await handleResponseStatus(error.response)
      return error.response
    },
  )

  const handleResponseStatus = async (response: any) => {
    switch (response?.status) {
      case 200:
        if (
          response.config.method !== 'get' &&
          !response.config.url.startsWith(end_points.userInvitation.url) &&
          !response.config.url.startsWith(end_points.userInvitationRegister.url)
        ) {
          toast.success(response.data.message)
        }
        break
      case 422:
        toast.error(response.data.errors[0].msg)
        break
      case 500:
        if (!response.config.url.startsWith(end_points.userInvitation.url)) {
          toast.error('Internal server error')
        }
        break
      case 502:
        toast.error('Internal server error')
        break
      case 404:
        toast.error(response.data.message)
        break
      case 409:
        toast.error(response.data.message)
        break
      case 401:
        toast.error('Unauthorized request')
        setTimeout(() => {
          store.dispatch(logout())
        }, 1000)
        break
      default:
        // showError('Error type not found')
        break
    }
  }

  return (
    <AxiosContext.Provider value={{ axiosInstance }}>
      {loading && <Loader />}
      {props.children}
    </AxiosContext.Provider>
  )
}

export default AxiosProvider
